import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Constantes } from 'src/app/components/shared/constant/constantes';
import { EncuestaSatisfaccion } from 'src/app/components/shared/entities/EncuestaSatisfaccion';
import { VisualizadorService } from 'src/app/components/shared/service/visualizador.service';

@Component({
  selector: 'app-encuesta',
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.css']
})
export class EncuestaComponent implements OnInit {

  public PREGUNTA_FACILIDAD = 'La facilidad para encontrar la información:';
  public PREGUNTA_ORGANIZACION = 'La presentación, organización y formato en que se encuentra la información:';
  public PREGUNTA_UTILIDAD = 'Utilidad y detalle de la información suministrada:';

  public PREGUNTA_ACTIVIDAD_ECONOMICA = 'En qué sector o actividad económica se desempeña';
  public PREGUNTA_OCUPACION = 'Cuál es su ocupación';
  public PREGUNTA_PROPOSITO = 'Cuál es el principal propósito para la consulta de esta información';
  public PREGUNTA_FRECUENCIA = 'Con qué frecuencia consulta esta información';

  public constante: Constantes = new Constantes();
  public detalleEncuesta: EncuestaSatisfaccion = new EncuestaSatisfaccion();
  public isAgradecimientos: boolean = false;

  public calificacion: string = '';
  public razonCalificacion: string = '';

  public actividadEconomica: string = '';
  public ocupacion: string = '';
  public proposito: string = '';
  public frecuencia: string = '';

  public facilidad: number = 0;
  public organizacion: number = 0;
  public utilidad: number = 0;

  public camposRequeridos = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<EncuestaComponent>, private service: VisualizadorService) { }

  ngOnInit(): void {
    this.detalleEncuesta = this.data.dataKey;
    this.isAgradecimientos = false;
    this.camposRequeridos = 0;
  }

  enviarCalificacion() {
    this.camposRequeridos = 0;
    var fechaFinal: Date = new Date();
    this.detalleEncuesta.fechaFinal = fechaFinal.getTime();
    this.detalleEncuesta.productoOrigen = 'CATALOGO';

    if (this.calificacion.length > 0 && this.razonCalificacion.length > 0 && this.facilidad > 0 && this.organizacion > 0 && this.utilidad > 0
      && this.actividadEconomica.length > 0 && this.ocupacion.length > 0 && this.proposito.length > 0 && this.frecuencia.length > 0) {
      //ENCUESTA BASICA
      this.detalleEncuesta.calificacion = this.calificacion;
      this.detalleEncuesta.razonCalificacion = this.razonCalificacion;

      //ENCUESTA CERTIFICADA
      this.detalleEncuesta.accesibilidadDatos = this.PREGUNTA_FACILIDAD + this.facilidad;
      this.detalleEncuesta.ordenDatos = this.PREGUNTA_ORGANIZACION + this.organizacion;
      this.detalleEncuesta.utilidadDatos = this.PREGUNTA_UTILIDAD + this.utilidad;
      this.detalleEncuesta.actividadEconomica = this.PREGUNTA_ACTIVIDAD_ECONOMICA + ':' + this.actividadEconomica;
      this.detalleEncuesta.ocupacion = this.PREGUNTA_OCUPACION + ':' + this.ocupacion;
      this.detalleEncuesta.propositoDatos = this.PREGUNTA_PROPOSITO + ':' + this.proposito;
      this.detalleEncuesta.frecuenciaConsultaDatos = this.PREGUNTA_FRECUENCIA + ':' + this.frecuencia;
      this.service.generarEncuestaSatisfaccion(this.detalleEncuesta!).subscribe({
        next: (jsonResponse) => {
          console.log('jsonResponse', jsonResponse);
        },
        error: (error) => {
          console.log("Error inesperado en getInformacionMenu", error);
        }
      });
      this.isAgradecimientos = true;
    } else {
      this.camposRequeridos = 1;
      this.isAgradecimientos = false;
    }

  }

  enviarEncustaCertificada() {
    this.isAgradecimientos = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
